import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { ArrowLeft } from "lucide-react";

export const BlogPost2 = () => {
  return (
    <>
      <Helmet>
        <title>Types of Coating Machines for Packaging Industry | Hero Impex Guide</title>
        <meta name="description" content="Complete guide to coating machine types: hot melt, solvent, water-based. Compare features, applications, costs. Expert advice from Hero Impex India." />
      </Helmet>

      <article className="min-h-screen bg-white">
        <div className="bg-gradient-to-br from-slate-900 to-slate-800 text-white py-12">
          <div className="container mx-auto px-4 max-w-4xl">
            <Link to="/blog" className="inline-flex items-center gap-2 text-amber-400 hover:text-amber-300 mb-6">
              <ArrowLeft className="w-4 h-4" />
              Back to Blog
            </Link>
            <Badge className="mb-4 bg-amber-500">Equipment Guide</Badge>
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Types of Coating Machines for Packaging Industry
            </h1>
            <p className="text-xl text-slate-300">Coming Soon - Detailed comparison of hot melt, solvent-based, and water-based coating machines.</p>
            <div className="mt-6 text-sm text-slate-400">Published: January 9, 2025</div>
          </div>
        </div>
        
        <div className="container mx-auto px-4 max-w-4xl py-12">
          <div className="bg-amber-50 border-l-4 border-amber-500 p-6 mb-8">
            <p className="text-slate-700">This article is currently being written. Please check back soon or contact us for immediate assistance.</p>
          </div>
          
          <Link to="/contact">
            <Button className="bg-gradient-to-r from-amber-500 to-amber-600">
              Contact Us for Expert Guidance
            </Button>
          </Link>
        </div>
      </article>
    </>
  );
};
